module.exports = __webpack_public_path__ + "img/Ciptadana Multifinance.3ed87279.png";